module.exports = __webpack_public_path__ + "media/images/samples/home/main@2x-a6b55f41d40550bfaae4c1b4af7ade2f.png";